export const formatDateToMonthDayYear = (date) => {
    return `${ date.getMonth() + 1 } - ${ date.getDate() } - ${ date.getFullYear() }`;
};

export const preventTypingInDateInputs = (event) => {
    event.preventDefault();
};